'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentUnionpayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M71.9363 8.71197L55.9282 8.70789C55.9262 8.70789 55.924 8.70789 55.924 8.70789C55.9117 8.70789 55.8996 8.71006 55.8875 8.71006C53.6883 8.7767 50.9493 10.5212 50.4505 12.6724L42.8801 45.8034C42.3813 47.9746 43.7384 49.7414 45.9216 49.7739H62.7387C64.8886 49.6687 66.9778 47.9442 67.4681 45.8175L75.0388 12.6863C75.5456 10.493 74.1558 8.71197 71.9363 8.71197Z",
          fill: "#01798A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M42.8804 45.8034L50.4508 12.6724C50.9496 10.5212 53.6886 8.77669 55.8877 8.71005L49.5229 8.70597L38.0556 8.7038C35.8503 8.7484 33.0756 10.5052 32.577 12.6724L25.0044 45.8034C24.5037 47.9746 25.8628 49.7414 28.0446 49.7739H45.9218C43.7386 49.7414 42.3815 47.9746 42.8804 45.8034Z",
          fill: "#024381"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M25.0043 45.8034L32.5769 12.6724C33.0756 10.5052 35.8502 8.74843 38.0555 8.70382L23.3651 8.70001C21.1475 8.70001 18.3042 10.4769 17.7975 12.6724L10.2248 45.8034C10.1788 46.0056 10.1532 46.2037 10.1379 46.3976V47.0123C10.2862 48.595 11.5083 49.7475 13.265 49.7739H28.0445C25.8627 49.7414 24.5036 47.9746 25.0043 45.8034Z",
          fill: "#DD0228"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M38.3652 32.8452H38.6432C38.8987 32.8452 39.0706 32.7604 39.1511 32.5925L39.8735 31.5232H41.8081L41.4047 32.2265H43.7243L43.4301 33.3042H40.6699C40.352 33.7772 39.9607 33.9996 39.4902 33.9732H38.0525L38.3652 32.8452H38.3652ZM38.0477 34.3897H43.1297L42.8057 35.5603H40.7619L40.4501 36.6903H42.4389L42.1149 37.8608H40.1261L39.6641 39.5304C39.5497 39.8095 39.7002 39.935 40.1129 39.9065H41.7338L41.4335 40.9943H38.3216C37.7317 40.9943 37.5294 40.6605 37.7144 39.9915L38.3051 37.8608H37.0339L37.3568 36.6903H38.6282L38.9398 35.5603H37.7246L38.0477 34.3897H38.0477ZM46.1588 31.5152L46.0788 32.2005C46.0788 32.2005 47.0374 31.4886 47.9081 31.4886H51.1252L49.8949 35.8936C49.7929 36.3972 49.3554 36.6476 48.5826 36.6476H44.9362L44.082 39.7408C44.0328 39.9065 44.1024 39.9915 44.2864 39.9915H45.0038L44.7401 40.9516H42.916C42.2159 40.9516 41.9247 40.7434 42.0402 40.3251L44.4538 31.5152H46.1588H46.1588H46.1588ZM48.8834 32.7604H46.0119L45.6684 33.949C45.6684 33.949 46.1466 33.6075 46.9458 33.5953C47.7427 33.583 48.6524 33.5953 48.6524 33.5953L48.8834 32.7604ZM47.843 35.5177C48.0553 35.5462 48.1741 35.4631 48.1884 35.267L48.3641 34.6404H45.4882L45.247 35.5177H47.843ZM45.9031 36.9409H47.5608L47.53 37.6504H47.9713C48.1944 37.6504 48.3049 37.5797 48.3049 37.4403L48.4355 36.9814H49.8133L49.6293 37.6504C49.4736 38.2084 49.0612 38.4995 48.3907 38.528H47.5077L47.5036 39.7408C47.4873 39.935 47.665 40.034 48.0307 40.034H48.8607L48.5928 40.9943H46.6021C46.0442 41.0205 45.7705 40.7576 45.7763 40.1998L45.9031 36.9409Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M25.8159 25.6465C25.5911 26.7361 25.0699 27.5731 24.2614 28.1674C23.4603 28.7516 22.427 29.0447 21.1619 29.0447C19.9714 29.0447 19.0986 28.7455 18.5416 28.1451C18.1553 27.7185 17.9631 27.1767 17.9631 26.5217C17.9631 26.2509 17.9959 25.9598 18.0613 25.6465L19.4092 19.2181H21.445L20.1154 25.5737C20.0745 25.7496 20.0582 25.9134 20.0603 26.061C20.0582 26.3865 20.1399 26.6533 20.3054 26.8614C20.5466 27.1708 20.938 27.3243 21.4827 27.3243C22.1091 27.3243 22.6253 27.1728 23.0259 26.8675C23.4265 26.5642 23.6881 26.1337 23.8056 25.5737L25.1393 19.2181H27.1648L25.8159 25.6465Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.3652 23.1176H35.9596L34.7107 28.8547H33.1195L34.3652 23.1176ZM34.867 21.0274H36.4755L36.175 22.42H34.5666L34.867 21.0274Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M37.3709 28.4181C36.9539 28.0239 36.7434 27.4922 36.7414 26.817C36.7414 26.7017 36.7485 26.5704 36.7639 26.4268C36.7793 26.2812 36.7987 26.1397 36.8262 26.0084C37.0153 25.0765 37.418 24.3366 38.0382 23.7907C38.6575 23.2429 39.4047 22.968 40.2795 22.968C40.9958 22.968 41.564 23.1661 41.98 23.5623C42.3958 23.9606 42.6043 24.4982 42.6043 25.1817C42.6043 25.2988 42.5952 25.4342 42.5798 25.5798C42.5614 25.7274 42.5391 25.8689 42.5133 26.0084C42.3285 26.9261 41.927 27.658 41.3066 28.1938C40.6862 28.7335 39.9412 29.0022 39.0725 29.0022C38.3531 29.0022 37.7869 28.8082 37.3709 28.4181M40.4093 27.282C40.6904 26.9808 40.8917 26.5238 41.0143 25.9154C41.0328 25.8204 41.049 25.7213 41.0592 25.6223C41.0693 25.5252 41.0735 25.4342 41.0735 25.3514C41.0735 24.9976 40.9824 24.7227 40.7996 24.5286C40.6178 24.3325 40.3593 24.2356 40.0252 24.2356C39.5835 24.2356 39.2238 24.389 38.942 24.6964C38.6576 25.0037 38.4563 25.4687 38.3295 26.0872C38.3122 26.1822 38.2979 26.2773 38.2847 26.3703C38.2745 26.4653 38.2715 26.5542 38.2734 26.635C38.2734 26.9868 38.3645 27.2577 38.5473 27.4497C38.7291 27.6418 38.9865 27.7368 39.325 27.7368C39.7686 27.7368 40.1283 27.5852 40.4093 27.282",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M52.9486 32.8938L53.333 31.5556H55.2767L55.1928 32.0466C55.1928 32.0466 56.1861 31.5556 56.9014 31.5556C57.6169 31.5556 59.3048 31.5556 59.3048 31.5556L58.9229 32.8938H58.5447L56.7317 39.2051H57.1098L56.7501 40.4585H56.372L56.2147 41.0022H54.3323L54.4894 40.4585H50.7758L51.1377 39.2051H51.5098L53.3245 32.8938H52.9486H52.9486ZM55.0456 32.8938L54.5509 34.6018C54.5509 34.6018 55.3973 34.2806 56.1269 34.1896C56.288 33.5931 56.4987 32.8938 56.4987 32.8938H55.0456V32.8938ZM54.3218 35.4025L53.8254 37.1916C53.8254 37.1916 54.7634 36.7347 55.4072 36.6963C55.5931 36.0048 55.7792 35.4025 55.7792 35.4025H54.3218V35.4025ZM54.6856 39.2051L55.0576 37.9073H53.6068L53.2328 39.2051H54.6856ZM59.3866 31.4727H61.214L61.2915 32.1396C61.2794 32.3094 61.3814 32.3905 61.5981 32.3905H61.921L61.5943 33.5204H60.2512C59.7383 33.5466 59.4746 33.3527 59.4501 32.9341L59.3866 31.4727ZM58.8513 33.8965H64.7703L64.423 35.1095H62.5385L62.2153 36.2373H64.098L63.7484 37.4483H61.6516L61.1772 38.158H62.2035L62.4406 39.5791C62.4689 39.7206 62.5957 39.7893 62.8124 39.7893H63.1311L62.7961 40.9596H61.6678C61.0832 40.9881 60.781 40.794 60.7562 40.3756L60.4842 39.0778L59.5503 40.4585C59.3295 40.8486 58.9902 41.0306 58.5326 41.0022H56.8095L57.1447 39.8316H57.6823C57.9031 39.8316 58.0868 39.7346 58.2524 39.5386L59.714 37.4483H57.8294L58.1787 36.2373H60.2227L60.5478 35.1095H58.5018L58.8513 33.8965Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.6911 23.1155H29.1289L28.9645 23.9443L29.1708 23.7078C29.6369 23.2147 30.203 22.97 30.8714 22.97C31.4764 22.97 31.9127 23.1439 32.1867 23.4936C32.4564 23.8433 32.53 24.3265 32.4024 24.9471L31.6102 28.8567H30.1325L30.8479 25.313C30.9216 24.9471 30.9012 24.6742 30.7875 24.4982C30.6753 24.3224 30.4605 24.2356 30.1509 24.2356C29.7708 24.2356 29.4509 24.3527 29.1903 24.5852C28.9286 24.8197 28.756 25.1453 28.6711 25.5596L28.012 28.8567H26.5312L27.6911 23.1155Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M44.1798 23.1155H45.6188L45.4555 23.9443L45.6595 23.7078C46.1259 23.2147 46.6941 22.97 47.3604 22.97C47.9654 22.97 48.4026 23.1439 48.6743 23.4936C48.9424 23.8433 49.02 24.3265 48.8891 24.9471L48.1001 28.8567H46.6204L47.3359 25.313C47.4093 24.9471 47.389 24.6742 47.2765 24.4982C47.1599 24.3224 46.9493 24.2356 46.641 24.2356C46.2607 24.2356 45.942 24.3527 45.6782 24.5852C45.4164 24.8197 45.2429 25.1453 45.1612 25.5596L44.499 28.8567H43.0201L44.1798 23.1155",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M51.2929 19.5576H55.4707C56.2739 19.5576 56.8951 19.7376 57.3222 20.0912C57.7473 20.4491 57.9602 20.9627 57.9602 21.6317V21.6519C57.9602 21.7792 57.9517 21.9228 57.9396 22.0784C57.9189 22.232 57.8923 22.3876 57.8579 22.5494C57.6739 23.4349 57.2466 24.1465 56.5866 24.6863C55.9241 25.224 55.1396 25.4949 54.2362 25.4949H51.9958L51.3031 28.8567H49.3633L51.2929 19.5576M52.3372 23.8777H54.1954C54.6797 23.8777 55.0638 23.7664 55.344 23.5461C55.6221 23.3238 55.806 22.9842 55.9081 22.5233C55.9243 22.4382 55.9345 22.3615 55.9468 22.2908C55.9532 22.2241 55.9611 22.1572 55.9611 22.0928C55.9611 21.7631 55.8429 21.5246 55.6056 21.375C55.3685 21.2232 54.9967 21.1506 54.4814 21.1506H52.9034L52.3372 23.8777",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M66.6426 29.9667C66.0293 31.2563 65.4449 32.0082 65.1017 32.358C64.758 32.7038 64.0777 33.5084 62.4384 33.4476L62.5795 32.4632C63.9589 32.0428 64.7049 30.1484 65.1301 29.3096L64.6232 23.1317L65.6902 23.1176H66.5854L66.6816 26.9929L68.3594 23.1176H70.058L66.6426 29.9667",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M61.8926 23.5845L61.2178 24.0435C60.5127 23.4977 59.8689 23.16 58.6265 23.73C56.9339 24.5063 55.5196 30.4598 60.1797 28.4989L60.4453 28.8102L62.2787 28.8567L63.4826 23.447L61.8926 23.5845M60.8503 26.542C60.5558 27.4012 59.898 27.9692 59.3829 27.8075C58.8678 27.6499 58.6838 26.8209 58.9822 25.9598C59.2765 25.0986 59.9387 24.5326 60.4496 24.6943C60.9647 24.852 61.1506 25.6808 60.8503 26.542Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M55.9242 8.71867L49.5228 8.70599L55.8876 8.73316C55.8997 8.73316 55.9118 8.71867 55.9242 8.71867",
          fill: "#E02F41"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M49.5228 8.73988L38.1435 8.70001C38.1149 8.70001 38.0852 8.71269 38.0555 8.72539L49.5228 8.73988",
          fill: "#2E4F7D"
        }
      )
    ]
  }
);
const VpPaymentUnionpayAsset = forwardRef(PaymentUnionpayAsset);

export { VpPaymentUnionpayAsset as default };
